// PROV: Phase-1 clinical provenance transport — fail-open, fire-and-forget.
// A provenance failure must NEVER block or alter the prescribing workflow.
import api from "./api";
import { PROV_SCHEMA_VERSION } from "./provenanceCore";

// package.json version; no build hash is injected at build time (VERSIONING GAP)
const APP_BUILD = "frontend@0.1.0";

let _queue = [];
let _timer = null;

const _flush = () => {
  if (_timer) { clearTimeout(_timer); _timer = null; }
  const batch = _queue.splice(0, _queue.length);
  if (!batch.length) return Promise.resolve();
  return api.post("/provenance/events", { events: batch })
    .catch((e) => console.debug("[prov-fail-open]", e?.message));
};

export const provLog = (evt) => {
  try {
    const list = Array.isArray(evt) ? evt : [evt];
    list.forEach((e) => _queue.push({ ...e, application_build: APP_BUILD, provenance_schema_version: PROV_SCHEMA_VERSION }));
    if (!_timer) _timer = setTimeout(_flush, 800);
  } catch (e) { console.debug("[prov-fail-open]", e?.message); }
};

export const flushProv = () => {
  try { return _flush(); } catch (e) { console.debug("[prov-fail-open]", e?.message); return Promise.resolve(); }
};

export const provSnapshot = (snap) => {
  try {
    return api.post("/provenance/snapshot", { ...snap, application_build: APP_BUILD })
      .then((r) => r.data)
      .catch((e) => { console.debug("[prov-fail-open]", e?.message); return null; });
  } catch (e) { console.debug("[prov-fail-open]", e?.message); return Promise.resolve(null); }
};
